import { render, staticRenderFns } from "./weekNumber.vue?vue&type=template&id=fdc17e82&scoped=true&"
import script from "./weekNumber.vue?vue&type=script&lang=js&"
export * from "./weekNumber.vue?vue&type=script&lang=js&"
import style0 from "./weekNumber.vue?vue&type=style&index=0&id=fdc17e82&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdc17e82",
  null
  
)

export default component.exports